import { render } from "./AddBienModal.vue?vue&type=template&id=1e12f1b8"
import script from "./AddBienModal.vue?vue&type=script&lang=js"
export * from "./AddBienModal.vue?vue&type=script&lang=js"

import "./AddBienModal.vue?vue&type=style&index=0&id=1e12f1b8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__